import React, { useState, useRef, Fragment } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputKidsMulti from "../../helpers/InputKidsMulti";
import InputCombo from "../../helpers/InputCombo";
import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputDecimal from "../../helpers/InputDecimal";

import edit from "../../edit.png";
import trash from "../../trash.png";
import InputBankAccount from "../../helpers/InputBankAccount";

import back from "../../back.png";


function InvoiceKor(props)
{ 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [loaded, setLoaded] = useState(0);
    const [loadedOrg, setLoadedOrg] = useState(0);

    const [iloscWys, setIloscWys] = useState(3); 

    const pozycja_def =   {typ_wlasny: 'Inne',p_typy_oplat_id:-1, nazwa: '', ilosc: 0.00, jm:'sztuki', cena_j_netto: 0.00,cena_j_brutto: 0.00, stawka_vat: 0.00,razem_netto:0.0, razem_vat: 0.0, razem_brutto: 0.00, usunieta: 0 , id:-1,  };
    const pozycje = [ 
        //puste..        
    ];

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
    
        id: props.id,

        dziecko: null,
        rodzic: null,
        subkonto: null,
        subkonto_info: null,

        sposob_platnosci: 'Przelew',
        p_subkonta_id: '_x_',
        p_subkonta_id_valid: false,

        typ_dokumentu: 'r', // r lub f
        faktura_vat_postawa: 'netto',  //netto brutto

        powod_korekty: ' ',   

        stan_dokumentu: '',

        odsetki_ustawowe: '0',
        kwota_odsetek: 0.00,
        ilosc_dni_zwloki: 0.00,

        data_wystawienia: '',
        data_wystawienia_valid: false,
        data_sprzedazy: '',
        data_sprzedazy_valid: false,
        termin_platnosci: '',
        termin_platnosci_valid: false,

        okres_od: '',
        okres_do: '',
        wystawil: '',


        sp_nazwa: '',
        sp_adres: '',
        sp_adres_cd:'',
        sp_nip: '',
        sp_numer_rachunku: '',
        sp_wystawil: '',
        sp_numer_rachunku: '',

        kl_nazwa: '',
        kl_adres: '',
        kl_nip: '',

        kl_kr_nazwa: '',
        kl_kr_adres: '',
        kl_kr_adres_cd: '',

        platnik_nazwa: '',
        platnik_ulica_nr_domu: '',
        platnik_kod_pocztowy: '',
        platnik_miasto: '',
        platnik_nip: '',

        pozycje: pozycje,
        razem_brutto : 0.00,

    });


    const [rowOrginal, setRowOrginal] = useState([]);



    const [checked, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked);
      };


      const [checkedSp, setCheckedSp] = useState(false);
      const handleChangeSp = () => {
          setCheckedSp(!checkedSp);
        };


        const [checkedOdb, setCheckedOdb] = useState(false);
        const handleChangeOdb = () => {
            setCheckedOdb(!checkedOdb);
          };


    const onKidsSelected = (tab) => {
        setRow( {...row, ["dzieci"]: tab  } );
    }



    const valChangeListener = (filedName, val, correct, msg) => { 
        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      
  
  
          var sp = filedName.split('@');
   
  
  
          if(sp.length == 2 && row.faktura_vat_postawa == 'netto')
          {
              var inx    = sp[1];
              var filedN = sp[0];
  
              var newArr = new Array();
              var razemBrutto = 0.00;
              
              for(var k=0; k<row.pozycje.length;  k++)
              {            
                  if(k == inx)
                  {                    
                      row.pozycje[k][filedN] = val;                                    
                  }
  
                  var cena_j_netto  = parseFloat( row.pozycje[k]["cena_j_netto"]).toFixed(2) ;
                  var ilosc         = parseFloat( row.pozycje[k]["ilosc"]).toFixed(2) ;
                  var stawka_vat    = parseFloat( row.pozycje[k]["stawka_vat"]).toFixed(2) ;
  
                  if( isNaN(cena_j_netto)  ) cena_j_netto = 0;
                  if(isNaN(ilosc) ) ilosc = 0;
                  if(isNaN(stawka_vat) ) stawka_vat = 0;
  
                  var razemNetto = parseFloat( parseFloat(cena_j_netto) *  parseFloat(ilosc) ).toFixed(2);
  
                  var st = parseFloat( parseFloat(stawka_vat) / 100 ).toFixed(2);
                  var vat = parseFloat( parseFloat(razemNetto) * parseFloat(st) ).toFixed(2);
  
                  
  
                  var brutto = parseFloat( parseFloat(razemNetto) + parseFloat(vat) ).toFixed(2);
  
                //  console.log("Zmiana " + filedName+", netto: ", razemNetto,  "VAT: ", vat, "brutto: ",brutto);
                  
  
  
                  if( row.pozycje[k]["nazwa"].length < 1) 
                  {
                      brutto = 0.00;
                  }
              
                  row.pozycje[k]["kwota_netto"] = razemNetto;
                  row.pozycje[k]["kwota_vat"] = vat;
                  row.pozycje[k]["kwota_brutto"] = brutto;
  
                  row.pozycje[k]["cena_j_brutto"] = parseFloat( parseFloat(brutto) / parseFloat(ilosc) ).toFixed(2);;
  
      
  
                  newArr.push( row.pozycje[k] );                
              }
  
  
              for(var k=0; k<newArr.length;k++)
              {               
                  razemBrutto = parseFloat(  parseFloat( razemBrutto) + parseFloat( newArr[k]['kwota_brutto'])  ).toFixed(2);             
                 // console.log("Brutto (" + k + ") " + razemBrutto);
              }
   
  
   
  
              setRow( {...row, ['pozycje']:newArr,  ["razem_brutto"]: razemBrutto } ); 
  
              return;
          }
  
          if(sp.length == 2 && row.faktura_vat_postawa == 'brutto')
              {
                  var inx    = sp[1];
                  var filedN = sp[0];
      
                  var newArr = new Array();
                  var razemBrutto = 0.00;
                  
                  for(var k=0; k<row.pozycje.length;  k++)
                  {            
                      if(k == inx)
                      {                    
                          row.pozycje[k][filedN] = val;                                    
                      }
      
                      var cena_j_brutto  = parseFloat( row.pozycje[k]["cena_j_brutto"]).toFixed(2) ;
                      var ilosc         = parseFloat( row.pozycje[k]["ilosc"]).toFixed(2) ;
                      var stawka_vat    = parseFloat( row.pozycje[k]["stawka_vat"]).toFixed(2) ;
      
                      if( isNaN(cena_j_brutto)  ) cena_j_brutto = 0;
                      if(isNaN(ilosc) ) ilosc = 0;
                      if(isNaN(stawka_vat) ) stawka_vat = 0;
      
                      var brutto = parseFloat( cena_j_brutto * ilosc ).toFixed(2);
      
                      var st = parseFloat( stawka_vat / 100 ).toFixed(2);                
                      st     = parseFloat( parseFloat(st)  + 1.00 ).toFixed(2);
                 
  
                      var razemNetto = parseFloat(  parseFloat(brutto) /  parseFloat(st) ).toFixed(2);
      
                      var vat = parseFloat(  parseFloat(brutto) - parseFloat(razemNetto) ).toFixed(2);                              
  
                       
      
                      if( row.pozycje[k]["nazwa"].length < 1) 
                      {
                          brutto = 0.00;
                      }
                  
                      row.pozycje[k]["kwota_netto"] = razemNetto;
                      row.pozycje[k]["kwota_vat"] = vat;
                      row.pozycje[k]["kwota_brutto"] = brutto;
      
                      row.pozycje[k]["cena_j_netto"] =   parseFloat(   parseFloat( razemNetto) /  parseFloat( ilosc) ).toFixed(2);
      
                   
      
                      newArr.push( row.pozycje[k] );                
                  }
      
      
                  for(var k=0; k<newArr.length;k++)
                  {               
                      razemBrutto = parseFloat(  parseFloat( razemBrutto) + parseFloat( newArr[k]['kwota_brutto'])  ).toFixed(2);             
                     // console.log("Brutto (" + k + ") " + razemBrutto);
                  }
       
      
       
      
                  setRow( {...row, ['pozycje']:newArr,  ["razem_brutto"]: razemBrutto } ); 
      
                  return;
              }
  
  
          setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct  } );         
      }


 


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }







    const getTab = () => {
            
        
        props.mainView.setProgress(-2);


        var req = {
            id: props.id
        };

        fetch( Config.url + '/rest_v1_calc,details_invoice', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       // setTab(res.result);    
                       wypelnij(res.result);           
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }

    const wypelnij = (result) => {



        var poz = new Array();

        for(var k=0; k<result.pozycje.length; k++)
        {
            var nx =  {
                 typ_wlasny:  result.pozycje[k]["typ_wlasny"] ,
                 p_typy_oplat_id:  result.pozycje[k]["p_typy_oplat_id"] ,
                 nazwa:result.pozycje[k]["nazwa"] , 
                 ilosc: result.pozycje[k]["ilosc"] ,
                 jm:result.pozycje[k]["jm"] ,
                 cena_j_netto: result.pozycje[k]["cena_j_netto"] ,
                 cena_j_brutto: result.pozycje[k]["cena_j_brutto"] ,
                 stawka_vat: result.pozycje[k]["stawka_vat"] ,
                 kwota_brutto: result.pozycje[k]["kwota_brutto"] ,
                 kwota_netto: result.pozycje[k]["kwota_netto"] ,
                 kwota_vat: result.pozycje[k]["kwota_vat"] ,
                 usunieta: 0 ,
                 id:result.pozycje[k]["id"] ,
                 };

                      poz.push(nx);
        }

        //dodaj puste pozycje..
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
        poz.push( JSON.parse( JSON.stringify(pozycja_def) ) );
 

        setIloscWys(result.pozycje.length);


        var dt = {
      
            id: props.id,

            dziecko: result.dziecko,
            rodzic: result.rodzic,
            subkonto: result.subkonto,
            subkonto_info: result.subkonto_info,
    
            numer: result.numer,
            nazwa: result.nazwa,

            sposob_platnosci: result.sposob_platnosci,
            p_subkonta_id: result.p_subkonta_id,
            p_subkonta_id_valid: true,
    
            typ_dokumentu: result.typ_dokumentu, // r lub f
            faktura_vat_postawa: result.faktura_vat_postawa, // netto brutto
            powod_korekty: result.powod_korekty, 

            stan_dokumentu: result.stan_dokumentu,
            korekta_f_faktura_id: result.korekta_f_faktura_id,
    
            odsetki_ustawowe: result.odsetki_ustawowe,
            kwota_odsetek: result.kwota_odsetek,
            ilosc_dni_zwloki: result.ilosc_dni_zwloki,
    
            data_wystawienia: result.data_wystawienia,
            data_wystawienia_valid: true,
            data_sprzedazy: result.data_sprzedazy,
            data_sprzedazy_valid: true,
            termin_platnosci: result.termin_platnosci,
            termin_platnosci_valid: true,
    
            okres_od: result.okres_od,
            okres_do: result.okres_do,
            wystawil: '',


            sp_nazwa: result.sp_nazwa,
            sp_adres: result.sp_adres,
            sp_adres_cd: result.sp_adres_cd,
            sp_nip: result.sp_nip,
            sp_numer_rachunku: result.sp_numer_rachunku,
            sp_wystawil: result.sp_wystawil,
            sp_numer_rachunku: result.sp_numer_rachunku,

            kl_nazwa: result.kl_nazwa,
            kl_adres: result.kl_adres,
            kl_nip: result.kl_nip,
    
            kl_kr_nazwa: result.kl_kr_nazwa,
            kl_kr_adres: result.kl_kr_adres,
            kl_kr_adres_cd: result.kl_kr_adres_cd,            
    
            platnik_nazwa: result.platnik_nazwa,
            platnik_ulica_nr_domu: result.platnik_ulica_nr_domu,
            platnik_kod_pocztowy: result.platnik_kod_pocztowy,
            platnik_miasto: result.platnik_miasto,
            platnik_nip: result.platnik_nip,
            info_dodatkowe_na_fakturze: result.info_dodatkowe_na_fakturze,
    
            pozycje: poz,
            razem_brutto : result.razem_brutto,
    
        };


        setRow(dt);

        
    }






    
    const getTabOrg = () => {
            
        
        props.mainView.setProgress(-2);


        var req = {
            id: row.korekta_f_faktura_id
        };

        fetch( Config.url + '/rest_v1_calc,details_invoice', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       // setTab(res.result);    
                       wypelnijOrg(res.result);           
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }

    const wypelnijOrg = (result) => {



        var poz = new Array();

        for(var k=0; k<result.pozycje.length; k++)
        {
            var nx =  {
                 typ_wlasny:  result.pozycje[k]["typ_wlasny"] ,
                 p_typy_oplat_id:  result.pozycje[k]["p_typy_oplat_id"] ,
                 nazwa:result.pozycje[k]["nazwa"] , 
                 ilosc: result.pozycje[k]["ilosc"] ,
                 jm:result.pozycje[k]["jm"] ,
                 cena_j_netto: result.pozycje[k]["cena_j_netto"] ,
                 cena_j_brutto: result.pozycje[k]["cena_j_brutto"] ,
                 stawka_vat: result.pozycje[k]["stawka_vat"] ,
                 kwota_brutto: result.pozycje[k]["kwota_brutto"] ,
                 kwota_netto: result.pozycje[k]["kwota_netto"] ,
                 kwota_vat: result.pozycje[k]["kwota_vat"] ,
                 usunieta: 0 ,
                 id:result.pozycje[k]["id"] ,
                 };

                      poz.push(nx);
        }
 
  

        var dt = {
      
            id: props.id,

            dziecko: result.dziecko,
            rodzic: result.rodzic,
            subkonto: result.subkonto,
            subkonto_info: result.subkonto_info,
    
            numer: result.numer,
            nazwa: result.nazwa,

            sposob_platnosci: result.sposob_platnosci,
            p_subkonta_id: result.p_subkonta_id,
            p_subkonta_id_valid: true,
    
            typ_dokumentu: result.typ_dokumentu, // r lub f
            faktura_vat_postawa: result.faktura_vat_postawa, // r lub f
            powod_korekty: result.powod_korekty, 

            stan_dokumentu: result.stan_dokumentu,
            korekta_f_faktura_id: result.korekta_f_faktura_id,
    
            odsetki_ustawowe: result.odsetki_ustawowe,
            kwota_odsetek: result.kwota_odsetek,
            ilosc_dni_zwloki: result.ilosc_dni_zwloki,
    
            data_wystawienia: result.data_wystawienia,
            data_wystawienia_valid: true,
            data_sprzedazy: result.data_sprzedazy,
            data_sprzedazy_valid: true,
            termin_platnosci: result.termin_platnosci,
            termin_platnosci_valid: true,
    
            okres_od: result.okres_od,
            okres_do: result.okres_do,
            wystawil: '',


            sp_nazwa: result.sp_nazwa,
            sp_adres: result.sp_adres,
            sp_adres_cd: result.sp_adres_cd,
            sp_nip: result.sp_nip,
            sp_numer_rachunku: result.sp_numer_rachunku,
            sp_wystawil: result.sp_wystawil,
            sp_numer_rachunku: result.sp_numer_rachunku,

            kl_nazwa: result.kl_nazwa,
            kl_adres: result.kl_adres,
            kl_nip: result.kl_nip,
    
            kl_kr_nazwa: result.kl_kr_nazwa,
            kl_kr_adres: result.kl_kr_adres,
            kl_kr_adres_cd: result.kl_kr_adres_cd,            
    
            platnik_nazwa: result.platnik_nazwa,
            platnik_ulica_nr_domu: result.platnik_ulica_nr_domu,
            platnik_kod_pocztowy: result.platnik_kod_pocztowy,
            platnik_miasto: result.platnik_miasto,
            platnik_nip: result.platnik_nip,
            info_dodatkowe_na_fakturze: result.info_dodatkowe_na_fakturze,
    
            pozycje: poz,
            razem_brutto : result.razem_brutto,
    
        };


        setRowOrginal(dt);

        
    }






    const saveData = (e) => {



        if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }


    
            
        var iloscPoz = 0;
            for(var k=0; k<row.pozycje.length;  k++)
                { 
                    if(row.pozycje[k]['nazwa'].length > 0 &&  row.pozycje[k]['cena_j_netto'] != 0   )
                    {
                        iloscPoz++;
                    }
                }    

       


        if( iloscPoz < 1) 
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie dodano żadnej pozycji.' ,  "ok"  ,null); 
                    return; 
                }            
 

      


        props.mainView.setProgress(-2);


    
        fetch( Config.url + '/rest_v1_calc,update_invoice', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                props.mainView.showDialog( "Sukces", 'Dane zostały zapisane', "ok" , null); 
                             //   props.goBack();
                             getTab();
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }



    const goApprove = (e) =>
        {
     
        
            var ids = new Array();
        
            ids.push({
                id: row.id,
                title: "",
            });
            
        
           
        
            props.mainView.showDialog("Potwierdź", "Na pewno chcesz zatwierdzić ten dokument?", "yesno", (option)=>{
                  
                ///--------
                if(option == "yes")
                {
                            props.mainView.setProgress(-2);
        
                            var req = {
                                ids: ids,                        
                            }
        
                            fetch( Config.master + '/rest_v1_calc,approve', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 
        
                                        props.mainView.setProgress(-1);        
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        }else    
                                        {      
                                            props.mainView.showDialog( "Sukces", "Wystawiono dokumentów: " + res.result , "ok" , null);                               
                                            getTab();            
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        props.mainView.setProgress(-1);
                            });
                }//koniec yes
                //--------
            } );
        
        }

        

    const cancelInvoice = (e) => {

        
            var ids = new Array();
        
        
            ids.push({
                id: row.id,
                title: "",
            });
        
        
        
        
            props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz anulować  dokument \"" + row.numer + "\" ?", "yesno", (option)=>{
                          
                ///--------
                if(option == "yes")
                {
                            props.mainView.setProgress(-2);
        
                            var req = {
                                ids: ids,                            
                            }
        
                            fetch( Config.url + '/rest_v1_calc,cancel', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 
        
                                        props.mainView.setProgress(-1);        
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        }else    
                                        {      
                                            props.mainView.showDialog( "Sukces", "Dokumentów anulowanych lub usuniętych: " + res.result , "ok" , null);                               
                                            getTab();            
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        props.mainView.setProgress(-1);
                            });
                }//koniec yes
                //--------
            } );
        
        }
        

      
  const goPrint = (e) =>
            {         
                var ids = new Array();
            
               
                
                ids.push({
                    id: row.id,
                    title: "none"
                });
            
             
                 props.mainView.setProgress(-2);
            
                 var req = {
                     ids: ids,                            
                 }

                 fetch( Config.url + '/rest_v1_calc,print_selected', {
                     method: 'POST', 
                     body: JSON.stringify(req), 
                     headers: {
                         'Content-Type': 'application/json',                    
                         'X-Api-Key': props.userData.apiKey,
                         '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                         '_p_dziecko_id_': props.userData.p_dziecko_id,
                         '_sec_key_': Config.genXKey() ,
                     }
                 })
                 .then(res => res.json() )
                 .then(res => { 

                             props.mainView.setProgress(-1);        
                             if(res._sys_ == undefined)
                             {
                                 props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                             }else
                             if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                             {
                                 props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                             }else    
                             {      
                                if(res.status == 'OK')                  
                                {
                                        var pdfB64 = res.result;

                                      //  document.location.href = "data:application/pdf;base64," + pdfB64;

                                        var anchor = document.createElement('a');
                                        anchor.href = "data:application/pdf;base64," + pdfB64;
                                        anchor.target="_blank";
                                        anchor.click();
                                }
                             }
                 } )    
                 .catch(err => {          
                             props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                             props.mainView.setProgress(-1);
                 });
            
            }    
    
  const goSendByEmail = (e) =>
                {         
                    var ids = new Array();
                    ids.push({
                        id: row.id,
                        title: "none",
                    });
                
                 
                     props.mainView.setProgress(-2);
                
                     var req = {
                         ids: ids,                            
                     }
 
                     fetch( Config.url + '/rest_v1_calc,send_email_selected', {
                         method: 'POST', 
                         body: JSON.stringify(req), 
                         headers: {
                             'Content-Type': 'application/json',                    
                             'X-Api-Key': props.userData.apiKey,
                             '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                             '_p_dziecko_id_': props.userData.p_dziecko_id,
                             '_sec_key_': Config.genXKey() ,
                         }
                     })
                     .then(res => res.json() )
                     .then(res => { 
 
                                 props.mainView.setProgress(-1);        
                                 if(res._sys_ == undefined)
                                 {
                                     props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                 }else
                                 if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                 {
                                     props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                 }else    
                                 {      
                                    if(res.status == 'OK')                  
                                    {
                                        props.mainView.showDialog( "Error", "Wybrane dokumenty zostały przekazane do wysyłki." , "ok" , null);    
                                    }
                                 }
                     } )    
                     .catch(err => {          
                                 props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                 props.mainView.setProgress(-1);
                     });
                
                }    
        
                    
    const goSendBySMS = (e) =>
                    {         
                    var ids = new Array();
                    ids.push({
                        id: row.id,
                        title: "none",
                    });
                    
                     
                         props.mainView.setProgress(-2);
                    
                         var req = {
                             ids: ids,                            
                         }
     
                         fetch( Config.url + '/rest_v1_calc,send_sms_selected', {
                             method: 'POST', 
                             body: JSON.stringify(req), 
                             headers: {
                                 'Content-Type': 'application/json',                    
                                 'X-Api-Key': props.userData.apiKey,
                                 '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                 '_p_dziecko_id_': props.userData.p_dziecko_id,
                                 '_sec_key_': Config.genXKey() ,
                             }
                         })
                         .then(res => res.json() )
                         .then(res => { 
     
                                     props.mainView.setProgress(-1);        
                                     if(res._sys_ == undefined)
                                     {
                                         props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                     }else
                                     if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                     {
                                         props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                     }else    
                                     {      
                                        if(res.status == 'OK')                  
                                        {
                                            props.mainView.showDialog( "Error", "Wybrane dokumenty zostały przekazane do wysyłki." , "ok" , null);    
                                        }
                                     }
                         } )    
                         .catch(err => {          
                                     props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                     props.mainView.setProgress(-1);
                         });
                    
                    }    





    const onBack = (e) => {
        props.goBack();
    }



    const dodajPozycje = () => {
        setIloscWys(iloscWys + 1);
    }

    const usunPozycje = (e) => {

        var ix = e.target.getAttribute('ix');


        var newArr = new Array();
            
        for(var k=0;k<row.pozycje.length; k++)
        {
            if(k == ix)
            {
                row.pozycje[k]["nazwa"] = "";             
                row.pozycje[k]["usunieta"] = 1;             
                row.pozycje[k]["cena_j_netto"] = 0;             
                row.pozycje[k]["razem_brutto"] = 0;             
                row.pozycje[k]["ilosc"] = 0;             
            }

            newArr.push( row.pozycje[k] );
        }

        setRow( {...row, ['pozycje']:newArr } ); 
      
        //przelicz wszystko..
        setTimeout(  ()=> {
            valChangeListener("nazwa@"+k, "",true,"");
        }, 500 );

    }




    const itemsTypDokumentu = [    
        { v: 'r', title: 'Zwykłe rozliczenie' },        
        { v: 'f', title: 'Faktura' },         
    ]; 


    const itemsSposobPlatnoci = [    
        { v: 'Gotówka', title: 'Gotówka' },        
        { v: 'Przelew', title: 'Przelew' },         
    ]; 

    const itemsJM = [    
        { v: 'godzina', title: 'Godzina' },        
        { v: 'dzień',   title: 'Dzień' },         
        { v: 'sztuki',  title: 'Sztuki' },         
        { v: 'miesiąc', title: 'Miesiąc' },         
    ]; 


    const itemsTyp = [    
        { v: 'Czesne', title: 'Czesne' },        
        { v: 'Wyżywienie',   title: 'Wyżywienie' },         
        { v: 'Inne',  title: 'Inne' },                 
    ]; 


    const itemsOdsetki = [    
        { v: '1', title: 'Tak, naliczaj w przypadku braku płatności' },        
        { v: '0',   title: 'Nie, pomiń automatyczne naliczanie' },                        
    ]; 

    var xTitle = "TYTULLLL";
  

 


    if(loaded == 0)
    {
        setLoaded(1);
        getTab();
    }


    if(row.dziecko == null)
    {
        return <div>
            ....
        </div>
    }
 

    if(loadedOrg == 0)
    {
        setLoadedOrg(1);
        getTabOrg();
    }

    if(rowOrginal.pozycje == null)
        {
            return <div>
                ....
            </div>
        }



    var diff =  parseFloat( parseFloat(row.razem_brutto).toFixed(2) - parseFloat(rowOrginal.razem_brutto).toFixed(2) ).toFixed(2);


    return <div className="view_content">

                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                        

                        { 
                            row.stan_dokumentu == 10 &&
                            <h1 className="color_show2 paddingX">{row.nazwa + " " + row.numer} <span>&nbsp; (Wystawiony) &nbsp; </span> </h1>
                        }

                        { 
                            row.stan_dokumentu == 11 &&
                            <h1 className="color_show3 paddingX">{row.nazwa + " " + row.numer} <span>&nbsp; (Oczekuje na zatwierdzenie) &nbsp;</span> </h1>
                        }

                        { 
                            row.stan_dokumentu == 12 &&
                            <h1 className="color_deleted2 paddingX">{row.nazwa + " " + row.numer} <span>&nbsp; (Anulowany!) &nbsp;</span></h1> 
                        }

                   

                    {       
                        row.stan_dokumentu == 10 &&
                        <div className="table_mass">                           
                                <span className="btn" onClick={goPrint}>Drukuj</span>        
                                &nbsp;                   
                                <span className="btn" onClick={goSendByEmail}>Wyślij jako e-fakturę</span>                           
                                &nbsp;
                                <span className="btn" onClick={goSendBySMS}>Wyślij SMSem</span>                           
                        </div>
                    }


                      
                    <form className="eForm bg_center">

                            <div className="form_tab_title">Dziecko / Rodzic </div>
                            <div className="form_tab">               
                                    {row.dziecko.imie + " " + row.dziecko.nazwisko} /   {row.rodzic.imie + " " + row.rodzic.nazwisko}
                            </div>


                            <div className="form_tab_title">Dane podstawowe (nadrukowane na dokumencie)</div>
                            <div className="form_tab">
                           
                        
                                <div className="form_control">
                                        <div className="fieldName">Numer dokumentu* </div>
                                        <InputText   userData={props.userData} value={row.numer} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="numer" placeholder={""} className=' ' req='1'   />
                                </div>                                                   



                                <div className="form_control">
                                        <div className="fieldName">Data wystawienia* </div>
                                        <InputDate   userData={props.userData} value={row.data_wystawienia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia" placeholder={""} className=' ' req='1'   />
                                </div>

                                <div className="form_control">
                                        <div className="fieldName">Data sprzedaży* </div>
                                        <InputDate   userData={props.userData} value={row.data_sprzedazy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_sprzedazy" placeholder={""} className=' ' req='1'   />
                                </div>

                                <div className="form_control">
                                        <div className="fieldName">Termin płatności* </div>
                                        <InputDate   userData={props.userData} value={row.termin_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="termin_platnosci" placeholder={""} className=' ' req='1'   />
                                </div>

                                <div className="form_control">
                                                <div className="fieldName">Sposób płatności</div>
                                                <InputCombo items={itemsSposobPlatnoci} value={row.sposob_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sposob_platnosci" placeholder={""} className='  ' req='1'   />                                    
                                </div>

                                <br/>

                              
                                             <div className="form_control">
                                                <div className="fieldName">Konto</div>
                                                <fieldset>
                                                {row.subkonto.nazwa + " " + row.subkonto.numer_konta}                                
                                                </fieldset>
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Numer rach. do wpłat (nadrukowane na dokumencie)</div>
                                                <fieldset>
                                                    {row.sp_numer_rachunku}                                
                                                </fieldset>     
                                            </div>

                               

                              

                                {
                                    row.subkonto_info.type == 2 &&
                                    <div>
                                        <br/>
                                        <strong>Uwaga: Zastosowano indywidualne numery rachunków dla rodziców,  numer konta do wpłat to: {row.subkonto_info.numer_konta} </strong>
                                        <br/>
                                    </div>
                                }

                                {
                                    row.subkonto_info.type == 3 &&
                                    <div>
                                        <br/>
                                        <strong>Uwaga: Zastosowano indywidualne numery rachunków dla dzieci, numer konta do wpłat to: {row.subkonto_info.numer_konta}</strong>
                                        <br/>
                                    </div>
                                }
                             

                              

                            </div>


                            <br/>

                            <div className="form_tab_title">
                            
                                    <label className="switch" title={props.userData.dic.showmore}>                               
                                        <input type="checkbox" checked={checkedSp}  onChange={handleChangeSp}/>
                                        <span className="slider round"></span>
                                    </label>  
                                    &nbsp; Sprzedawca (nadrukowane na dokumencie)
                            </div>

                            { checkedSp && 
                             <div className="form_tab">
                                 

                                 <div className="form_control">
                                                    <div className="fieldName">NIP</div>
                                                    <InputNIP   userData={props.userData} value={row.sp_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sp_nip" placeholder={""} className='w200' req='1'   />
                                </div>

                                <div className="form_control">
                                                    <div className="fieldName">Nazwa</div>
                                                    <InputText   userData={props.userData} value={row.sp_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sp_nazwa" placeholder={""} className='w400' req='1'   />
                                </div>

                                <br/>


                                <div className="form_control">
                                                    <div className="fieldName">Adres (ulica, nr)</div>
                                                    <InputText   userData={props.userData} value={row.sp_adres} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sp_adres" placeholder={""} className='w300' req='1'   />
                                </div>

                                <div className="form_control">
                                                    <div className="fieldName">Adres cd. (kod, miasto)</div>
                                                    <InputText   userData={props.userData} value={row.sp_adres_cd} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sp_adres_cd" placeholder={""} className='w300' req='1'   />
                                </div>
 
                             </div>
                            }

                            <br/>

                            
                            <div className="form_tab_title">
                                 
                                    <label className="switch" title={props.userData.dic.showmore}>                               
                                        <input type="checkbox" checked={checkedOdb}  onChange={handleChangeOdb}/>
                                        <span className="slider round"></span>
                                    </label>  
                                    &nbsp;
                                    Odbiorca (nadrukowane na dokumencie)
                            </div>

                            { checkedOdb && 
                             <div className="form_tab">
                                 

                                 <div className="form_control">
                                                    <div className="fieldName">NIP</div>
                                                    <InputNIP   userData={props.userData} value={row.kl_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kl_nip" placeholder={""} className='w200' req='0'   />
                                </div>

                                <div className="form_control">
                                                    <div className="fieldName">Nazwa</div>
                                                    <InputText   userData={props.userData} value={row.kl_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kl_nazwa" placeholder={""} className='w400' req='0'   />
                                </div>

                                <br/>


                                <div className="form_control">
                                                    <div className="fieldName">Adres (Ulica, nr domu, kod, miasto)</div>
                                                    <InputText   userData={props.userData} value={row.kl_adres} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kl_adres" placeholder={""} className='w300' req='0'   />
                                </div>

                                
 
                             </div>
                            }

                            <br/>

                            <div className="form_tab_title">                                 
                                    <label className="switch" title={props.userData.dic.showmore}>                               
                                        <input type="checkbox" checked={checked}  onChange={handleChange}/>
                                        <span className="slider round"></span>
                                    </label>  
                                    &nbsp;
                                    Płatnik (nadrukowane na dokumencie / wypełnij jeżeli inny niż rodzic np. ośrodek pomocy społecznej, fundacja) 
                            </div>

                            { checked && 
                            <div className="form_tab">


                               <div className="form_control">
                                                    <div className="fieldName">NIP</div>
                                                    <InputNIP   userData={props.userData} value={row.platnik_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_nip" placeholder={""} className='w200' req='0'   />
                                </div>

                                <div className="form_control">
                                                    <div className="fieldName">Nazwa</div>
                                                    <InputText   userData={props.userData} value={row.platnik_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_nazwa" placeholder={""} className='w400' req='0'   />
                                </div>
                           

                                <br/>

                                <div className="form_control">
                                                    <div className="fieldName">Ulica, nr domu</div>
                                                    <InputText   userData={props.userData} value={row.platnik_ulica_nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_ulica_nr_domu" placeholder={""} className='w300' req='0'   />
                                </div>

                                <div className="form_control">
                                                    <div className="fieldName">Kod pocztowy</div>
                                                    <InputPostCode   userData={props.userData} value={row.platnik_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_kod_pocztowy" placeholder={""} className='w100' req='0'   />
                                </div>

                                <div className="form_control">
                                                    <div className="fieldName">Miasto</div>
                                                    <InputText   userData={props.userData} value={row.platnik_miasto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="platnik_miasto" placeholder={""} className='w200' req='0'   />
                                </div>

                            </div>
                            }

                            <br/>

                             {
                                rowOrginal.typ_dokumentu == 'f' &&
                                <Fragment>
                                        <div className="form_tab_title">Pozycje na pierwotnym dokumencie</div>
                                                                    <div className="form_tab">

                                                                            <table className="table" >
                                                                                        <thead>
                                                                                            <tr className="header">
                                                                                                <td>LP</td>
                                                                                                <td>Nazwa</td>
                                                                                                <td>Cena jednostkowa</td>
                                                                                                <td>Ilość</td>
                                                                                                <td>Stawka VAT</td>
                                                                                                <td>Razem brutto</td>                                                                                                                                                                                                                                  
                                                                                            </tr>
                                                                                        </thead>

                                                                                        <tbody>
                                                                                                {
                                                                                                    rowOrginal.pozycje.map(  (r, inx) => {
                                                                                                        return <tr className="row">
                                                                                                                    <td>{inx}</td>
                                                                                                                    <td>{r.nazwa}</td>
                                                                                                                    <td className="goright">{r.cena_j_netto}</td>
                                                                                                                    <td className="goright">{ parseFloat(r.ilosc).toFixed(2) }</td>
                                                                                                                    <td className="goright">{ parseFloat(r.stawka_vat).toFixed(2) }</td>
                                                                                                                    <td className="goright">{ parseFloat(r.kwota_brutto).toFixed(2) }</td>   
                                                                                                        </tr>
                                                                                                    } ) 
                                                                                                }
                                                                                        </tbody>
                                                                            </table>
                                                                    </div>
                                </Fragment>

                             }   


                             
                                {
                                rowOrginal.typ_dokumentu == 'r' &&
                                <Fragment>
                                        <div className="form_tab_title">Pozycje na pierwotnym dokumencie</div>
                                                                    <div className="form_tab">

                                                                            <table className="table" >
                                                                                        <thead>
                                                                                            <tr className="header">
                                                                                                <td>LP</td>
                                                                                                <td>Nazwa</td>
                                                                                                <td>Cena jednostkowa</td>
                                                                                                <td>Ilość</td>                                                                                
                                                                                                <td>Razem</td>                                                                                                                                                                                                                                  
                                                                                            </tr>
                                                                                        </thead>

                                                                                        <tbody>
                                                                                                {
                                                                                                    rowOrginal.pozycje.map(  (r, inx) => {
                                                                                                        return <tr className="row">
                                                                                                                    <td>{inx}</td>
                                                                                                                    <td>{r.nazwa}</td>
                                                                                                                    <td className="goright">{r.cena_j_netto}</td>
                                                                                                                    <td className="goright">{ parseFloat(r.ilosc).toFixed(2) }</td>                                                                                                         
                                                                                                                    <td className="goright">{ parseFloat(r.kwota_brutto).toFixed(2) }</td>   
                                                                                                        </tr>
                                                                                                    } ) 
                                                                                                }
                                                                                        </tbody>
                                                                            </table>
                                                                    </div>
                                </Fragment>

                             }   
                           
                           

                           {
                                rowOrginal.faktura_vat_postawa == 'netto' &&
                                <Fragment>
                                       <  div className="form_tab_title">Aktualne pozycje na rozliczeniu (podstawa: {rowOrginal.faktura_vat_postawa})</div>
                                                    <div className="form_tab">

                                                            {
                                                                row.pozycje.map((poz, ix) => {

                                                                    if(ix >= iloscWys) return null;
                                                                    if( row.pozycje[ix].usunieta == 1  ) return null;

                                                                    return <div>

                                                                        

                                                                            <div className="form_control"> 
                                                                                <div className="fieldName">Rodzaj</div>                                                       
                                                                                <InputCombo items={itemsTyp} value={row.pozycje[ix].typ_wlasny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"typ@"+ix} placeholder={""} className='  ' req='0'   />  
                                                                            </div>

                                                                            <div className="form_control">      
                                                                                <div className="fieldName">Nazwa pozycji</div>
                                                                                <InputText   userData={props.userData} value={row.pozycje[ix].nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"nazwa@"+ix} placeholder={"Nazwa: np. Czesne z X"} className='w200' req='0'   />
                                                                            </div>

                                                                            <div className="form_control">      
                                                                                <div className="fieldName">Cena netto</div>
                                                                                <InputDecimal   userData={props.userData} value={row.pozycje[ix].cena_j_netto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"cena_j_netto@"+ix} placeholder={"Cena:"} className='w100' req='0'   />
                                                                            </div>

                                                                            <div className="form_control">      
                                                                                <div className="fieldName">Ilość</div>
                                                                                <InputDecimal   userData={props.userData} value={row.pozycje[ix].ilosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"ilosc@"+ix} placeholder={"Ilość:"} className='w100' req='0'   />
                                                                            </div>

                                                                            <div className="form_control"> 
                                                                                <div className="fieldName">JM</div>                                                       
                                                                                <InputCombo items={itemsJM} value={row.pozycje[ix].jm} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"jm@"+ix} placeholder={""} className='  ' req='0'   />  
                                                                            </div>


                                                                            <div className="form_control">      
                                                                                <div className="fieldName">Stawka VAT</div>
                                                                                <InputDecimal   userData={props.userData} value={row.pozycje[ix].stawka_vat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"stawka_vat@"+ix} placeholder={"Stawka VAT:"} className='w50' req='0'   />
                                                                            </div>

                                                                            {
                                                                                                      row.typ_dokumentu == 'f' &&
                                                                                                      <div className="form_control">                                                                                                 
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_netto).toFixed(2) }<br/>netto</div>                                                                                                   
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_vat).toFixed(2) }<br/>vat</div>                                                                                            
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_brutto).toFixed(2) }<br/>brutto</div>
                                                                                                      </div>
                                                                                                }
                                                                                               
                                                                                               {
                                                                                                      row.typ_dokumentu == 'r' &&
                                                                                                      <div className="form_control">                                                                                                                                                                                                                                                                                          
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_brutto).toFixed(2) } razem</div>
                                                                                                      </div>
                                                                                                }

                                                                            <div className="form_control"> 
                                                                            &nbsp; &nbsp;   <img className="ibtn" src={trash} title="usuń"  onClick={usunPozycje}   ix={ix} />
                                                                            </div>

                                                                            

                                                                    </div>


                                                                } )

                                                            }

                                                    
                                                        <span onClick={dodajPozycje} className="link_color">
                                                            dodaj pozycje +
                                                        </span>   

                                                            <br/>
                                                            <br/>
                                                        
                                                        
                        

                                                            <table className="table">

                                                                <tr>
                                                                    <td className="">Razem:</td>
                                                                    <td className=" goright">{ parseFloat(row.razem_brutto).toFixed(2) }</td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="">Razem  ( z dok. {rowOrginal.numer} ):</td>
                                                                    <td className=" goright">{ parseFloat(rowOrginal.razem_brutto).toFixed(2) }</td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="gobold">

                                                                        {
                                                                        diff < 0 &&
                                                                        <span>Do zwrotu</span>
                                                                        }

                                                                        {
                                                                        diff > 0 &&
                                                                        <span>Do zapłaty</span>
                                                                        }

                                                                        {
                                                                        diff == 0 &&
                                                                        <span>Do zapłaty / Zwrotu</span>
                                                                        }

                                                                    </td>

                                                                    <td className="goright gobold">
                                                                        {
                                                                            diff < 0 &&
                                                                            <span>
                                                                                    {  parseFloat(-1 * diff).toFixed(2)  }
                                                                            </span>
                                                                        }

                        {
                                                                            diff >= 0 &&
                                                                            <span>
                                                                                    {  parseFloat(  diff).toFixed(2)  }
                                                                            </span>
                                                                        }
                                                                            
                                                                    </td>
                                                                </tr>

                                                            </table> 

                                                        
                                                        

                                                    </div>
                                </Fragment>
                           }
                            

                            {
                                rowOrginal.faktura_vat_postawa == 'brutto' &&
                                <Fragment>
                                       <  div className="form_tab_title">Aktualne pozycje na rozliczeniu  (podstawa: {rowOrginal.faktura_vat_postawa})</div>
                                                    <div className="form_tab">

                                                            {
                                                                row.pozycje.map((poz, ix) => {

                                                                    if(ix >= iloscWys) return null;
                                                                    if( row.pozycje[ix].usunieta == 1  ) return null;

                                                                    return <div>

                                                                        

                                                                            <div className="form_control"> 
                                                                                <div className="fieldName">Rodzaj</div>                                                       
                                                                                <InputCombo items={itemsTyp} value={row.pozycje[ix].typ_wlasny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"typ@"+ix} placeholder={""} className='  ' req='0'   />  
                                                                            </div>

                                                                            <div className="form_control">      
                                                                                <div className="fieldName">Nazwa pozycji</div>
                                                                                <InputText   userData={props.userData} value={row.pozycje[ix].nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"nazwa@"+ix} placeholder={"Nazwa: np. Czesne z X"} className='w200' req='0'   />
                                                                            </div>

                                                                            <div className="form_control">      
                                                                                <div className="fieldName">Cena brutto</div>
                                                                                <InputDecimal   userData={props.userData} value={row.pozycje[ix].cena_j_brutto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"cena_j_brutto@"+ix} placeholder={"Cena:"} className='w100' req='0'   />
                                                                            </div>

                                                                            <div className="form_control">      
                                                                                <div className="fieldName">Ilość</div>
                                                                                <InputDecimal   userData={props.userData} value={row.pozycje[ix].ilosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"ilosc@"+ix} placeholder={"Ilość:"} className='w100' req='0'   />
                                                                            </div>

                                                                            <div className="form_control"> 
                                                                                <div className="fieldName">JM</div>                                                       
                                                                                <InputCombo items={itemsJM} value={row.pozycje[ix].jm} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"jm@"+ix} placeholder={""} className='  ' req='0'   />  
                                                                            </div>


                                                                            <div className="form_control">      
                                                                                <div className="fieldName">Stawka VAT</div>
                                                                                <InputDecimal   userData={props.userData} value={row.pozycje[ix].stawka_vat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"stawka_vat@"+ix} placeholder={"Stawka VAT:"} className='w50' req='0'   />
                                                                            </div>

                                                                            {
                                                                                                      row.typ_dokumentu == 'f' &&
                                                                                                      <div className="form_control">                                                                                                 
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_netto).toFixed(2) }<br/>netto</div>                                                                                                   
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_vat).toFixed(2) }<br/>vat</div>                                                                                            
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_brutto).toFixed(2) }<br/>brutto</div>
                                                                                                      </div>
                                                                                                }
                                                                                               
                                                                                               {
                                                                                                      row.typ_dokumentu == 'r' &&
                                                                                                      <div className="form_control">                                                                                                                                                                                                                                                                                          
                                                                                                            <div className="labAmount">{ parseFloat( row.pozycje[ix].kwota_brutto).toFixed(2) } razem</div>
                                                                                                      </div>
                                                                                                }

                                                                            <div className="form_control"> 
                                                                            &nbsp; &nbsp;   <img className="ibtn" src={trash} title="usuń"  onClick={usunPozycje}   ix={ix} />
                                                                            </div>

                                                                            

                                                                    </div>


                                                                } )

                                                            }

                                                    
                                                        <span onClick={dodajPozycje} className="link_color">
                                                            dodaj pozycje +
                                                        </span>   

                                                            <br/>
                                                            <br/>
                                                        
                                                        
                        

                                                            <table className="table">

                                                                <tr>
                                                                    <td className="">Razem:</td>
                                                                    <td className=" goright">{ parseFloat(row.razem_brutto).toFixed(2) }</td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="">Razem  ( z dok. {rowOrginal.numer} ):</td>
                                                                    <td className=" goright">{ parseFloat(rowOrginal.razem_brutto).toFixed(2) }</td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="gobold">

                                                                        {
                                                                        diff < 0 &&
                                                                        <span>Do zwrotu</span>
                                                                        }

                                                                        {
                                                                        diff > 0 &&
                                                                        <span>Do zapłaty</span>
                                                                        }

                                                                        {
                                                                        diff == 0 &&
                                                                        <span>Do zapłaty / Zwrotu</span>
                                                                        }

                                                                    </td>

                                                                    <td className="goright gobold">
                                                                        {
                                                                            diff < 0 &&
                                                                            <span>
                                                                                    {  parseFloat(-1 * diff).toFixed(2)  }
                                                                            </span>
                                                                        }

                                                                        {
                                                                            diff >= 0 &&
                                                                            <span>
                                                                                    {  parseFloat(  diff).toFixed(2)  }
                                                                            </span>
                                                                        }
                                                                            
                                                                    </td>
                                                                </tr>

                                                            </table> 

                                                        
                                                        

                                                    </div>
                                </Fragment>
                           }


                           
                        <div className="form_tab_title">Informacje dodatkowe</div>
                            <div className="form_tab">
                                   <div className="form_control">
                                                    <div className="fieldName">Powód korekty(...)</div>
                                                    <InputText   userData={props.userData} value={row.powod_korekty} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="powod_korekty" placeholder={""} className='w400' req='0'   />
                                    </div>
                            </div>


                         


                            {
                                  row.stan_dokumentu == 10 && 
                                  <div>
                                        <div className="form_tab_title">Odsetki</div>
                                            <div className="form_tab">   
                                                        

                                                                <div className="form_control"> 
                                                                        <div className="fieldName">Odsetki ustawowe</div>                                                       
                                                                        <InputCombo items={itemsOdsetki} value={row.odsetki_ustawowe} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odsetki_ustawowe"} placeholder={""} className='  ' req='0'   />  
                                                                    </div>


                                                                    <div className="form_control">      
                                                                        <div className="fieldName">Ilość dni po terminie</div>
                                                                        <InputDecimal   userData={props.userData} value={row.ilosc_dni_zwloki} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"ilosc_dni_zwloki"} placeholder={":"} className='w100' req='0'   />
                                                                    </div>

                                                                    <div className="form_control">      
                                                                        <div className="fieldName">Kwota odsetek</div>
                                                                        <InputDecimal   userData={props.userData} value={row.kwota_odsetek} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kwota_odsetek"} placeholder={":"} className='w100' req='0'   />
                                                                    </div>

                                            </div>
                                   </div>
                            }

                            


                            <div className="form_split"></div>

                            <div className="form_btn">

                                    { 
                                        row.stan_dokumentu == 10 &&
                                        <div className="btn" onClick={saveData}>Zaktualizuj</div>
                                    }

                                    {   
                                        row.stan_dokumentu == 11 &&
                                        <div className="btn" onClick={saveData}>Zaktualizuj</div>
                                    }

                                    &nbsp;

                                    {   
                                        row.stan_dokumentu == 11 &&
                                        <div className="btn" onClick={goApprove}>Wystaw / Zatwierdź</div>
                                    }


                                    {   
                                        row.stan_dokumentu == 10 &&
                                        <div className="btn btn_red" onClick={cancelInvoice}>Anuluj dokument</div>
                                    }

                            
                                    &nbsp;
                                    <div className="btn" onClick={onBack}>Wstecz</div>
                            </div>


                    </form>


                   

    </div>
}



export default InvoiceKor;


